import { render, staticRenderFns } from "./ClientsReviewsSlider.vue?vue&type=template&id=39ed5e44"
import script from "./ClientsReviewsSlider.vue?vue&type=script&lang=js"
export * from "./ClientsReviewsSlider.vue?vue&type=script&lang=js"
import style0 from "./ClientsReviewsSlider.vue?vue&type=style&index=0&id=39ed5e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StarRatingDisplay: require('/app/components/StarRatingDisplay.vue').default,SsrCarousel: require('/app/node_modules/vue-ssr-carousel/index.js').default,ModalReview: require('/app/components/ModalReview.vue').default})
